import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

/** "Ada Lovelace" → "AL", "ada.lovelace@x.com" → "AL". */
export function initials(name: string) {
    const parts = name.replace(/@.*/, '').split(/[\s._-]+/).filter(Boolean);
    return ((parts[0]?.[0] ?? '?') + (parts[1]?.[0] ?? '')).toUpperCase();
}

/** "3 minutes ago" */
export function timeAgo(iso: string | Date) {
    return dayjs(iso).fromNow();
}

/** "1 vote", "3 votes"; `many` for irregular words ("2 people"). */
export function plural(n: number, one: string, many = `${one}s`) {
    return `${n} ${n === 1 ? one : many}`;
}
